var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import ProductSlider from './ProductSlider';
import { PRODUCT_PAGE_QUERY_BY_ID } from 'graphql/queries';
import { useAnalytics, useBrowser } from 'hooks';
import { Map, ProductJourneyContainer } from 'components/Shared/ProductJourney';
import styled, { useTheme } from 'styled-components';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import useMeasure from 'react-use-measure';
import ActiveProvider from 'components/Shared/ProductJourney/Context/ActiveContext';
import client from 'utils/graphql-client';
import { fetchWithCacheClientSide } from 'utils/fetchWithCacheClientSide';
import { convertHexToRGBA } from 'utils/color';
import 'react-loading-skeleton/dist/skeleton.css';
import { useStackableContent } from '../StackedContent/StackableContentContext';
const ProductContainer = styled.div `
  width: 100%;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  color: #0f1412;
  font-family: Lato;
`;
const Container = styled.div `
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &.map-desktop {
    height: 450px;

    @media screen and (min-height: 700px) {
      height: 530px;
    }
  }
`;
const ScrollContainer = styled.div `
  overflow: auto;
  margin: 16px;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border-radius: 7.5px;
`;
const SkeletonContainer = styled.div `
  margin: 0 16px;
  width: calc(100% - 32px);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
`;
const MapSkeleton = styled(Skeleton) `
  width: 100%;
  border-radius: 4px;
  height: 350px;

  @media screen and (min-height: 700px) {
    height: 430px;
  }
`;
const MapPreviewImage = styled.img `
  position: absolute;
  top: 2px; // Fix image shift caused by Skeleton
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const ProductSelectorContainer = ({ products = [], locale = 'en', }) => {
    const { deactivateAllStackedContents } = useStackableContent();
    const [activeProduct, setActiveProduct] = useState(products[0]);
    const [data, setData] = useState({
        loading: true,
        result: {
            allProductInfoById: undefined,
        },
    });
    const { trackSteps } = useAnalytics();
    const { isMobile } = useBrowser();
    const { palette } = useTheme();
    const [ref, { width }] = useMeasure();
    useEffect(() => {
        if (products.length > 0) {
            setActiveProduct(products[0]);
        }
    }, [products]);
    const request = () => client.request(PRODUCT_PAGE_QUERY_BY_ID, {
        id: activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id,
        published: true,
        lang: locale,
    });
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            setData({
                loading: true,
                // @ts-ignore
                result: { allProductInfoById: undefined },
            });
            const result = yield fetchWithCacheClientSide(activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id, {
                request,
                forceRefresh: false,
                preview: false,
                locale: locale,
            });
            setData({
                loading: false,
                // @ts-ignore
                result: { allProductInfoById: result === null || result === void 0 ? void 0 : result.allProductInfoById },
            });
        });
        fetchData();
    }, [activeProduct, locale]);
    const handleClickProduct = (product) => {
        deactivateAllStackedContents(0);
        setActiveProduct(product);
    };
    const { loading, result: { allProductInfoById: { 
    // @ts-ignore
    productId, 
    // @ts-ignore
    supplyChain = {
        stepsSerialized: [],
    }, 
    // @ts-ignore
    latestTraceableRawMaterials, 
    // @ts-ignore
    latestBatchTracingDate, 
    // @ts-ignore
    currentLang, } = {}, } = {}, } = data;
    return (React.createElement(ProductContainer, { ref: ref },
        width > 0 && (React.createElement(ProductSlider, { activeProduct: activeProduct, setActiveProduct: handleClickProduct, products: products, containerWidth: width })),
        (loading || !supplyChain) && (React.createElement(SkeletonTheme, { baseColor: convertHexToRGBA(palette.grey['A800'], 0.2), highlightColor: convertHexToRGBA(palette.grey[700], 0.2) },
            React.createElement(SkeletonContainer, null,
                React.createElement(MapPreviewImage, { className: "st-product-overview-slider-skeleton", src: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/map-preview.png` }),
                React.createElement(MapSkeleton, null)))),
        !loading && !!supplyChain && activeProduct && (React.createElement(ScrollContainer, null,
            React.createElement(Container, { className: isMobile ? 'map-mobile' : 'map-desktop' },
                React.createElement(ActiveProvider, { lang: currentLang, productId: productId, 
                    // @ts-ignore
                    supplyChain: supplyChain, latestBatch: latestTraceableRawMaterials && latestBatchTracingDate
                        ? {
                            date: latestBatchTracingDate,
                            rawMaterials: latestTraceableRawMaterials,
                        }
                        : undefined, isIntegration: true, trackSteps: trackSteps },
                    React.createElement(ProductJourneyContainer, { MapComponent: Map, showProductJourneyCards: true })))))));
};
export default ProductSelectorContainer;
